import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { vendorsService } from '@/services/vendorsService'

export const useVendorsStore = defineStore('vendors', () => {
  const vendors = ref([])
  const loading = ref(false)
  const error = ref(null)


  const getVendorBySlug = computed(() => {
      return (slug) => vendors.value.find(vendor => vendor.slug === slug)
  })
const fetchVendors = async () => {
      if (vendors.value.length > 0) return // Don't fetch if we already have vendors
      
      loading.value = true
      error.value = null
      
      try {
        vendors.value = await vendorsService.getAllVendors()
      } catch (err) {
        error.value = 'Failed to load vendors'
        console.error('Error fetching vendors:', err)
      } finally {
        loading.value = false
      }
    }
    return {
      // State
      vendors,
      loading,
      error,
      
      // Getters
      getVendorBySlug,
      
      // Actions
      fetchVendors
    }
}) 